export const LOGSTYPES: {[key:string] : string } = {
    PHOTO_COVER: 'PHOTO_COVER',
    PHOTO_LOGO: 'PHOTO_LOGO',
  }